// FOCUS on /visitors/new.html.erb form input#visitor_email
$(document).ready( function() {
  $('input#visitor_email').focus()
  });
